<template>
  <div class="customer-search-by-name-input-component">
    <a-select
            label-in-value
            v-model="selectValue"
            placeholder="Zoek een klant"
            style="display:block;"
            :show-search="true"
            :filter-option="false"
            :allow-clear="allowClear"
            :show-arrow="false"
            :not-found-content="fetching || noResults ? undefined : null"
            :loading="fetching"
            :disabled="disabled"
            @focus="onFocus"
            @blur="onBlur"
            @search="searchCustomer"
            @change="handleChange"
    >
        <span v-if="fetching" slot="notFoundContent">Zoeken...</span>
        <span v-if="noResults" slot="notFoundContent">Geen resultaten</span>
        <a-select-option v-for="customer in customers" :key="customer.id">
            <customer-highlighted-name-component :customer="customer"/>
        </a-select-option>
    </a-select>
    <input type="hidden" :name="inputName" :value="selectedCustomerId">
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import customerApi from "~/api/customer"
import CustomerHighlightedNameComponent from "./HighlightedNameComponent";

export default {
  name: "CustomerSearchByNameInputComponent",
  components: {CustomerHighlightedNameComponent},
  props: {
    value: {
      type: [String, Number],
      required: false,
    },
    inputName: {
      type: String,
      required: false,
      default: "customer_id"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.lastFetchId = 0;
    this.searchCustomer = debounce(this.searchCustomer, 600);
    return {
      customers: [],
      selectValue: {},
      fetching: false
    };
  },
  mounted() {
    if (typeof this.value !== "undefined" && this.value !== null) {
      customerApi.find(this.value).then((response) => {
        // TODO: refactor label to use same component as is being used to display
        this.selectValue = {
          key: this.value,
          label: this.label(response.data)
        }
      })
    }
  },
  computed: {
    noResults() {
      return this.customers.length === 0 && this.focused && !this.fetching;
    }
    ,
    selectedCustomerId() {
      if (typeof this.selectValue === "object") {
        return this.selectValue.key;
      }
      return null;
    }
  },
  methods: {
    label(customer) {
      if (customer.is_business) {
        return customer.business_name;
      } else {
        return `${customer.suffix ? customer.suffix : ""} ${customer.last_name} (${customer.first_name}) - ${customer.age} jaar`;
      }
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
    searchCustomer(query) {
      if (query.length === 0) {
        return;
      }
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.customers = [];
      this.fetching = true;
      customerApi.search(query)
        .then(response => {
          if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
          }
          this.customers = response.data;
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    handleChange(customer) {
      if (typeof customer !== "undefined") {
        customer.highlight = null;
        this.$emit("change", customer.key);
        this.$emit("input", customer.key);
      } else {
        this.$emit("change", null);
        this.$emit("input", null);
      }

      Object.assign(this, {
        customers: [],
        fetching: false,
      });

    },
  }
}
</script>
<style scoped>
</style>
